import React, { useState, useEffect } from "react";
import JobApplicationForm from "./JobApplicationForm";
import "../styles/CareerPartnership.css";

const API_URL = "https://backend.afrivisionconsultants.com";
// const API_URL = "http://localhost:5000";

const CareerPartnership = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // State to control Modals
  const [formType, setFormType] = useState(null); // 'JOB' or 'PARTNERSHIP' or null
  
  const [selectedRole, setSelectedRole] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/public/roles`)
      .then(res => res.json())
      .then(data => setRoles(data.roles || []))
      .catch(err => console.error("Failed to fetch roles:", err))
      .finally(() => setLoading(false));
  }, []);

  const openJobForm = () => setFormType("JOB");
  const openPartnerForm = () => setFormType("PARTNERSHIP");
  const closeForm = () => setFormType(null);

  return (
    <section className="career-partnership-section" id="career-Partnership">
      <div className="container">
        <h1 className="page-title">Careers & Partnerships</h1>

        <div className="content-container">
          
          {/* --- CAREERS SECTION --- */}
          <div className="career-box" id="careers">
            <div className="box-content">
              <h2>Join Our Team</h2>
              <p>Explore exciting opportunities to work with us.</p>
              
              {loading ? (
                <p className="status-text">Loading positions...</p>
              ) : roles.length > 0 ? (
                <div className="job-list-container">
                  <ul className="job-list">
                    {roles.map((role) => (
                      <li key={role.id} className="job-item">
                        <div>
                          <strong className="job-title">{role.title}</strong>
                        </div>
                        
                        <button 
                          className="view-details-btn"
                          onClick={() => setSelectedRole(role)}
                        >
                          View Details
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p className="status-text">No open positions at the moment. Check back later!</p>
              )}
            </div>

            <button className="apply-btn" onClick={openJobForm}>
              Apply Now
            </button>
          </div>

          {/* --- PARTNERSHIP SECTION --- */}
          <div className="partnership-box" id="partnership">
            <div className="box-content">
              <h2>Partner With Us</h2>
              <p>
                We welcome strategic partnerships with NGOs, Corporates, and Individuals.
              </p>
              <ul className="partnership-list">
                <li>NGOs & Non-Profits</li>
                <li>Corporate CSR Initiatives</li>
                <li>Educational Institutions</li>
              </ul>
            </div>
            
            <div className="partner-actions">
                <a 
                  href="mailto:info@afrivisionconsultants.com"
                  className="partner-btn email-btn"
                >
                  Email Us
                </a>
                
                <button
                  className="partner-btn proposal-btn"
                  onClick={openPartnerForm}
                >
                  Submit Proposal
                </button>
            </div>
          </div>
        </div>
      </div>

      {/* --- ROLE DETAILS MODAL --- */}
      {selectedRole && (
        <div className="modal-overlay" onClick={() => setSelectedRole(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '600px', width: '90%' }}>
            
            <button className="modal-close-btn" onClick={() => setSelectedRole(null)}>&times;</button>
            
            <h2 style={{ marginTop: 0, color: '#333' }}>{selectedRole.title}</h2>
            
            <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', color: '#666', fontSize: '0.9rem' }}>
              <span><strong>Location:</strong> {selectedRole.location}</span>
              <span><strong>Type:</strong> {selectedRole.type}</span>
            </div>
            
            {/* Typed Description Area */}
            <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '5px', marginBottom: '20px' }}>
              <h4 style={{ marginTop: 0 }}>Job Description</h4>
              {selectedRole.description ? (
                <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6', fontSize: '0.95rem' }}>
                  {selectedRole.description}
                </div>
              ) : (
                <p style={{ fontStyle: 'italic', color: '#999', margin: 0 }}>Check job Requirements below under view/Download</p>
              )}
            </div>

            {/* Uploaded File Area */}
            {selectedRole.descriptionFile && (
              <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #e0e0e0', borderRadius: '5px' }}>
                <h4 style={{ marginTop: 0, marginBottom: '10px' }}>Attached Document</h4>
                <a 
                  href={`${API_URL}/uploads/roles/${selectedRole.descriptionFile}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ 
                    display: 'inline-block', 
                    padding: '8px 15px', 
                    background: '#e1f5fe', 
                    color: '#0277bd', 
                    textDecoration: 'none', 
                    borderRadius: '4px', 
                    fontWeight: 'bold' 
                  }}
                >
                  📄 View / Download File
                </a>
              </div>
            )}

            {/* Apply Button inside the Modal */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #eee', paddingTop: '15px' }}>
              <button 
                className="apply-btn" 
                onClick={() => {
                  setSelectedRole(null); // Close the details view
                  openJobForm();         // Open the application form
                }}
                style={{ width: '100%', padding: '12px', fontSize: '1.1rem', cursor: 'pointer' }}
              >
                Apply for this Role
              </button>
            </div>

          </div>
        </div>
      )}

      {/* --- REUSABLE FORM MODAL --- */}
      {formType && (
        <div className="modal-overlay" onClick={closeForm}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeForm}>&times;</button>
            <JobApplicationForm 
                onClose={closeForm} 
                type={formType} 
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default CareerPartnership;